import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const AllInOne = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2.001 1.01h12a.333.333 0 0 1 .333.333v8.666a.333.333 0 0 1-.333.334h-12a.333.333 0 0 1-.333-.334V1.343a.333.333 0 0 1 .333-.333Zm11.667.666H2.335v8h11.333v-8ZM15.334 16.342H.667a.333.333 0 0 1-.333-.333v-2a2.336 2.336 0 0 1 2.333-2.333h10.667a2.336 2.336 0 0 1 2.333 2.333v2a.333.333 0 0 1-.333.333ZM1 15.676h14v-1.667a1.668 1.668 0 0 0-1.667-1.667H2.667a1.67 1.67 0 0 0-1.666 1.667v1.667Z" />
      <path d="M4.001 3.01h8a.333.333 0 0 1 .334.333V8.01a.333.333 0 0 1-.334.333h-8a.333.333 0 0 1-.333-.333V3.343a.333.333 0 0 1 .333-.333Zm7.667.666H4.335v4h7.333v-4ZM4 14.342h-.667a.333.333 0 1 1 0-.666H4a.333.333 0 1 1 0 .666ZM12.667 14.342H9.333a.333.333 0 1 1 0-.666h3.334a.333.333 0 1 1 0 .666Z" />
    </svg>
  );
};

AllInOne.category = 'product-category';

AllInOne.displayName = 'AllInOne';
